<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>listBlacklist.title</h3>
        </span>
    </div>

    <div class="my-2 py-2">
        <!-- Search Form -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- text search -->
                <div class="input-group-prepend">
                    <span class="input-group-text" translate>listBlacklist.search</span>
                </div>
                <input type="text" class="form-control d-inline" (keyup.enter)="search()" formControlName="q">

                <!-- channel filter -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listBlacklist.channel</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="channelFilter">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option value="SMS_ONLY" translate>listBlacklist.channel.smsOnly</option>
                    <option value="EMAIL_ONLY" translate>listBlacklist.channel.emailOnly</option>
                    <option value="BOTH" translate>listBlacklist.channel.both</option>
                </select>

                <!-- reason filter -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listBlacklist.reason</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="reason">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option value="gdpr-request" translate>blacklist.reason.gdpr</option>
                    <option value="unsubscribe" translate>blacklist.reason.unsubscribe</option>
                    <option value="spam-complaint" translate>blacklist.reason.spam</option>
                    <option value="other" translate>blacklist.reason.other</option>
                </select>

                <!-- actions -->
                <div class="input-group-prepend ml-2">
                    <div style="display: flex;">
                        <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                        <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                        <button class="btn btn-outline-success ml-2" style="border-radius: 0;" routerLink="/add-edit-blacklist" type="button"
                                *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_BLACKLIST)" translate>button.add</button>
                    </div>
                </div>
            </div>
        </form>

        <br>

        <!-- Table -->
        <div class="d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th translate>listBlacklist.createdOn</th>
                        <th translate>listBlacklist.createdBy</th>
                        <th translate>listBlacklist.channel</th>
                        <th translate>listBlacklist.phone</th>
                        <th translate>listBlacklist.email</th>
                        <th translate>listBlacklist.reason</th>
                        <th translate>listBlacklist.note</th>
                        <th translate>listBlacklist.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of content">
                        <td>{{toDate(entry.createdOn) | date: 'dd.MM.yyyy HH:mm'}}</td>
                        <td>{{entry.createdBy}}</td>
                        <td>{{channelLabel(entry)}}</td>
                        <td>{{entry.phone}}</td>
                        <td>{{entry.email}}</td>
                        <td><span translate>{{reasonKey(entry)}}</span></td>
                        <td>{{entry.note}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" routerLink="/add-edit-blacklist"
                                *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_BLACKLIST)"
                                data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}"
                                [queryParams]="{id: entry.id}">
                                <i class="fa fa-pencil fa-lg"></i>
                            </button>
                            <button class="btn btn-sm btn-danger ml-1" type="button"
                                *ngIf="entry.id && perms.hasAccess(perms.CAN_ADD_EDIT_BLACKLIST)"
                                data-toggle="tooltip" data-placement="bottom" title="{{'button.delete' | translate}}"
                                (click)="delete(entry.id)">
                                <i class="fa fa-trash fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>

        <!-- Pagination -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" [ngModelOptions]="{standalone: true}" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                    {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
